<template>
 <div>
   <journal-web-component 
   :tool.prop="{...tool}" 
   :user="user && user.uid" 
   :focus.prop="{...focus}"
   :set-tracker.prop="(p) => $store.dispatch('tools/setTrackerInTool', p)"
    />
  </div>
</template>

<script>

import Vue from "vue"

window.Vue = Vue
const JournalWebComponent = () => import("./wc/journal-web-component")

Vue.use(JournalWebComponent)

export default {
  name: 'toolwindow-default',
  components: {
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default:()=>{}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    },
    typeaheadApps: {
      type: Array,
      default: () => ['Maps','Calculator']
    },
    idprop: {
      type: String
    }
  },
  methods:{
  },
  computed: {
  },
  data: function() {
    return {
    }
  },
  mounted(){
  }
}

 // handleChooseDefaultTool(defaultType, tool) {
    //   this.defaultTool = defaultType;
    //   this.$store.dispatch('tools/setTrackerInTool', {
    //     focusId: this.focus.focusId,
    //     userUid: this.$store.getters['user/user'].uid,
    //     tool: {...tool, settings: {type: defaultType}},
    //     defaultType: defaultType
    //   })
    // },
    // handleClickCheckin(tool) {
    //   let updatedTool;
    //   this.checkInAt = new Date();
    //   if (tool.tracks) {
    //     updatedTool = {...tool, tracks: [...tool.tracks, {
    //       _created_at: this.checkInAt
    //     }]}
    //   } else {
    //     updatedTool = {...tool, tracks: [{_created_at: this.checkInAt }]}
    //   }
    //   this.$store.dispatch('tools/setTrackerInTool', {focusId: this.focus.focusId, userUid: this.$store.getters['user/user'].uid, tool: updatedTool })
    // },
    // handleClickLogger(tool) {
    //   let updatedTool;
    //   this.checkInAt = new Date();
    //   if(tool.tracks) {
    //     updatedTool = {...tool, tracks: [...tool.tracks, {text: this.noteForLogger, _created_at: this.checkInAt }]}
    //   } else {
    //     updatedTool = {...tool, tracks: [{text: this.noteForLogger, _created_at: this.checkInAt}]}
    //   }
    //   this.$store.dispatch('tools/setTrackerInTool', {focusId: this.focus.focusId, userUid: this.$store.getters['user/user'].uid, tool: updatedTool }).then(() => this.noteForLogger = "")
    // },
    // handleStartPauseResumeTimer(tool, type) {
    //   let updatedTool
    //   let tracks = tool.tracks

    //   if(type === "start") {
    //     // setTimeout(() => {
    //       // let tracks2 = tool.tracks
    //       this.start = true;
    //       tracks[tracks.length-1] = {...tracks[tracks.length-1], _started_at: new Date()} 
    //       updatedTool = {...tool, tracks}
    //     // }, 1000);
    //   } else if(type === "pause") {
    //     this.pause = true
    //     tracks[tracks.length-1] = {...tracks[tracks.length-1], _paused_at: new Date()} 
    //     updatedTool = {...tool, tracks}
    //   } else if(type === "resume") {
    //     this.pause = false
    //     tracks[tracks.length-1] = {...tracks[tracks.length-1], _resumed_at: new Date()} 
    //     updatedTool = {...tool, tracks}
    //   } else if(type === "blur") {
    //     if(tool.tracks) {
    //       updatedTool = {...tool, tracks: [...tool.tracks, { _created_at: new Date()}]}
    //     } else {
    //       updatedTool = {...tool, tracks: [{ _created_at: new Date()}]}
    //     }
    //   }
    //   this.$store.dispatch('tools/setTrackerInTool', {focusId: this.focus.focusId, userUid: this.$store.getters['user/user'].uid, tool: updatedTool })
    // },
    // setSettings() {
    //   this.showModalAppStore = true;
    // },
    // handleStoreClick() {
    //     this.showModalAppStore = true;
    // },

  //     data: function() {
  //   return {
  //     // showTracking: false,
  //     // checkInAt: null,
  //     // settings,
  //     // toolconfig,
  //     // tooltype: 'checkin',
  //     // showModalAppStore: false,
  //     // selectedAppConnection: null,
  //     // defaultTool: this.tool.settings && this.tool.settings.type ? this.tool.settings.type : "" ,
  //     // noteForLogger: "",
  //     // // timer needs
  //     // start: false,
  //     // pause: false,
  //     // timeP: "30",
  //     datacollection: null
  //   }
  // },
</script>
<style lang="scss" module>
  @import './style.module.scss';
</style>
<style scoped>
  .notepad {
    background-color: rgb(255, 242, 204);
    border-radius: 5px;
    width: 100%;
    height: 125px;
  }
  .card-body {
    overflow-y: auto;
  }
</style>
